import scrollListenWithRequestAnimationFrame from 'shared/assets/scripts/scrollListenWithRequestAnimationFrame'

export default class Header {
	private header: HTMLElement | null
	private rootElement: HTMLElement
	private lastScrollTop: number
	private scrollThreeshold: number

	constructor() {
		this.header = document.querySelector('.header')
		this.rootElement = document.documentElement

		this.lastScrollTop = 0
		this.scrollThreeshold = 100

		this.toggleHeaderUI = this.toggleHeaderUI.bind(this)
	}

	init() {
		if (this.header) {
			this.addEvents()
		}
	}

	addEvents() {
		scrollListenWithRequestAnimationFrame(this.toggleHeaderUI)
	}

	toggleHeaderUI() {
		if (!this.header) return

		const { scrollY } = window
		const hasScrolledMoreThanThreshold =
			Math.abs(scrollY - this.lastScrollTop) >= this.scrollThreeshold

		this.header.classList.toggle('isSticky', scrollY > this.scrollThreeshold)

		if (hasScrolledMoreThanThreshold) {
			this.header.classList.toggle('isSticky-active', this.lastScrollTop > scrollY)
			this.rootElement.classList.toggle('headerIsStickyActive', this.lastScrollTop > scrollY)
			this.lastScrollTop = scrollY
		}

		/*
			Expose the header UI state to the entire DOM so that any element can adapt
			based on whether the header is sticky or not
		*/
		this.rootElement.classList.toggle('headerIsSticky', scrollY > this.scrollThreeshold)
	}
}
